import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getExternalLoginUrl, getIsOnDemand } from "~/store/selectors/selector.configOptions";
import { getLoggedUserId } from "~/store/selectors/selector.users";
import { activecollab_site_url_login } from "~/utils/urls";

export const RequireAuth = ({ children, redirectTo }) => {
  const loggedUserId = useSelector(getLoggedUserId);
  const isOnDemand = useSelector(getIsOnDemand);
  const externalLogin = useSelector(getExternalLoginUrl);

  if (!loggedUserId) {
    if (typeof isOnDemand !== "undefined" && isOnDemand && !(process.env.NODE_ENV === "development")) {
      window.location = externalLogin ?? `${activecollab_site_url_login}`;
      return null;
    }

    return <Navigate to={redirectTo} />;
  }

  return children;
};

RequireAuth.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireAuth.defaultProps = {
  redirectTo: "/login",
};
